import Navbar from "../Navbar/Navbar";
import SlidingHeader from "../SlidingHeader/SlidingHeader";
import Footer from "../Footer/Footer";
import ProductFullDetails from "./ProductFullDetails/ProductFullDetails";
import ProductFullDetailsMobile from "./ProductFullDetailsMoble/ProductFullDetailsMobile";
import { useMediaQuery } from "react-responsive";
function PageProductFullDetails() {
  const isMobile = useMediaQuery({ maxWidth: 600 });
  return (
    <>
      <div className="ppfd-container">
        <SlidingHeader />
        <Navbar />
        {isMobile ? <ProductFullDetailsMobile /> : <ProductFullDetails />}
        <Footer />
      </div>
    </>
  );
}

export default PageProductFullDetails;
